import { createServerFn } from '@tanstack/react-start';

const fetchSpace = createServerFn().handler(async () => {
  const { loadSpace } = await import('#/lib/loader.server');
  return loadSpace();
});

type Space = Awaited<ReturnType<typeof fetchSpace>>;

let browserSpace: Promise<Space> | null = null;

/**
 * The space is fixed per host, so the browser fetches it once instead of on
 * every client-side navigation. The server resolves it per request.
 */
export function getSpace(): Promise<Space> {
  if (typeof window === 'undefined') return fetchSpace();

  browserSpace ??= fetchSpace().catch((error: unknown) => {
    browserSpace = null;
    throw error;
  });

  return browserSpace;
}
